export default __webpack_public_path__ + "static/media/marker-pb.0e2a7c3c.png";